import { NotificationService } from "@cradua/core";
import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  first,
  withLatestFrom,
  switchMap,
} from "rxjs/operators";
import { of } from "rxjs";
import * as PipelinedetailsActions from "./pipelinedetails.actions";
import { PipelinedetailsService } from "../../service/pipelinedetails.service";
import {
  PipelinedetailsStoreSelectors,
  PipelinedetailsStoreReducer,
} from "./index";
import { select, Store } from "@ngrx/store";

@Injectable()
export class PipelinedetailsEffects {
  loadPipelinedetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PipelinedetailsActions.loadPipelinedetails),
      exhaustMap((_) =>
        this.pipelinedetailsService.getPipelinedetails().pipe(
          map((data) =>
            PipelinedetailsActions.loadPipelinedetailsSuccess({
              Pipelinedetails: data,
            })
          ),
          catchError((error) =>
            of(
              PipelinedetailsActions.loadPipelinedetailsFailure({
                error,
              }),
            )
          ),
        )
      ),
    )
  );


  clearPipelinedetails$ = createEffect(() =>
  this.actions$.pipe(
    ofType(PipelinedetailsActions.clearPipelinedetails),
    exhaustMap((_) => of(PipelinedetailsActions.loadPipelinedetailsSuccess({
            Pipelinedetails: [],
          }))))
);

  fetchPipelinedetailsRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PipelinedetailsActions.fetchPipelinedetailsRecord),
      switchMap(({ fetch }) =>
        of(fetch).pipe(
          withLatestFrom(
            this.store.select(PipelinedetailsStoreSelectors.getAllPipelinedetails),
          ),
        )
      ),
      switchMap(([result, res]) => {
        // console.log("result ", res);
        return this.pipelinedetailsService.fetchPipelinedetails(result).pipe(
          map((data) =>
            PipelinedetailsActions.fetchPipelinedetailsRecordSuccess({ record: data })
          ),
          catchError((error) => {
            this.notification.error(error.error.message);
            return of(
              PipelinedetailsActions.fetchPipelinedetailsRecordFailure({ error }),
            );
          }),
        );
      }),
    )
  );

  fetchByIdPipelinedetailsRecord$ = createEffect(() =>
  this.actions$.pipe(
    ofType(PipelinedetailsActions.fetchByIdPipelinedetailsRecord),
    switchMap(({ id }) =>
      of(id).pipe(
        withLatestFrom(
          this.store.select(PipelinedetailsStoreSelectors.getAllPipelinedetails),
        ),
      )
    ),
    switchMap(([result, res]) => {
      // console.log("result ", res);
      return this.pipelinedetailsService.fetchByIdPipelinedetails(result).pipe(
        map((data) =>
          PipelinedetailsActions.fetchByIdPipelinedetailsRecordSuccess({ record: data })
        ),
        catchError((error) => {
          this.notification.error(error.error.message);
          return of(
            PipelinedetailsActions.fetchByIdPipelinedetailsRecordFailure({ error }),
          );
        }),
      );
    }),
  )
);


  addPipelinedetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PipelinedetailsActions.addPipelinedetails),
      concatMap(({ newPipelinedetails }) =>
        this.pipelinedetailsService.createPipelinedetails(newPipelinedetails)
          .pipe(
            map((data) => {
              this.notification.success("Saved Successfully");
              return PipelinedetailsActions.addPipelinedetailsSuccess(
                {
                  newPipelinedetails: data,
                },
              );
            }),
            catchError((error) =>
              of(
                PipelinedetailsActions.addPipelinedetailsFailure(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  updatePipelinedetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PipelinedetailsActions.updatePipelinedetails),
      map((action) => action.updatePipelinedetails),
      concatMap((updatePipelinedetails) =>
        this.pipelinedetailsService
          .updatePipelinedetails(updatePipelinedetails)
          .pipe(
            map((mapPipelinedetails) => {
              console.log('update ', mapPipelinedetails)
              this.notification.success("Updated Successfully");
              return PipelinedetailsActions.updatePipelinedetailsSuccess(
                {
                  updatePipelinedetails: mapPipelinedetails,
                },
              );
            }),
            catchError((error) =>
              of(
                PipelinedetailsActions.updatePipelinedetailsFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  removePipelinedetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PipelinedetailsActions.removePipelinedetails),
      map((action) => action.id),
      concatMap((id) =>
        this.pipelinedetailsService
          .deletePipelinedetails(id)
          .pipe(
            map(() => {
              this.notification.success("Deleted Successfully");
              return PipelinedetailsActions.removePipelinedetailsSuccess(
                { id },
              );
            }),
            catchError((error) =>
              of(
                PipelinedetailsActions.updatePipelinedetailsFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<PipelinedetailsStoreReducer.PipelinedetailsPartialState>,
    private pipelinedetailsService: PipelinedetailsService,
    private notification: NotificationService,
  ) {}
}